import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarCNPJ, formatarCPF } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
 
 
 
export default function PendenciaMercado({
  pendenciaMercado
}: {
    pendenciaMercado: any
}) {
  const { t } = useTranslation();
  
  if(pendenciaMercado.vecGateway.debitos && pendenciaMercado.vecGateway.debitos.ocorrencia && !Array.isArray(pendenciaMercado.vecGateway.debitos.ocorrencia)){
    const registros = []
    registros.push(pendenciaMercado.vecGateway.debitos.ocorrencia)
    pendenciaMercado.vecGateway.debitos.ocorrencia = registros;
  }

  if(pendenciaMercado.vecGateway.registro_scpc_bvs && pendenciaMercado.vecGateway.registro_scpc_bvs.registros && !Array.isArray(pendenciaMercado.vecGateway.registro_scpc_bvs.registros)){
    const registros = []
    registros.push(pendenciaMercado.vecGateway.registro_scpc_bvs.registros)
    pendenciaMercado.vecGateway.registro_scpc_bvs.registros = registros;
  }

  if(pendenciaMercado.vecGateway.consultas_anteriores && pendenciaMercado.vecGateway.consultas_anteriores.ocorrencia && !Array.isArray(pendenciaMercado.vecGateway.consultas_anteriores.ocorrencia)){
    const ocorrencia = []
    ocorrencia.push(pendenciaMercado.vecGateway.consultas_anteriores.ocorrencia)
    pendenciaMercado.vecGateway.consultas_anteriores.ocorrencia = ocorrencia;
  }
 
 
  const numberFormat = (value:number, width:number) => {
    return new Array(width + 1 - (value + '').length).join('0') + value;
  }
 
  const dateFormat = (value:number) => {
    const data = value + '';
    return data.substring(6,8) + '/' + data.substring(4,6) + '/' + data.substring(0,4);
  }
 
  const dateTemplate = (item:any) => {
    return dateFormat(item.data)
  }
 
  const dateOcorrenciaTemplate = (item:any) => {
    return dateFormat(item.data_ocorrencia)
  }
 
  const dateRegistroTemplate = (item:any) => {
    return dateFormat(item.data_disponilizacao)
  }
  
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    if(pendenciaMercado.vecGateway.sintese_cadastral.cpf){
      return  <div className={className}> {pendenciaMercado.vecGateway.registro_scpc_bvs.registros && pendenciaMercado.vecGateway.registro_scpc_bvs.registros.length > 0 ? (<span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('registros')}</span></span>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('registros')}</span>) }</div>;
    }
    else{
      return <div className={className}> {pendenciaMercado.vecGateway.debitos.ocorrencia && pendenciaMercado.vecGateway.debitos.ocorrencia.length > 0 ? (<span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('registros')}</span></span>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('registros')}</span>) }</div>;
    }
    
  }
 
 
  
  return (
    <div>
    {pendenciaMercado.vecGateway.mensagem ? (<Panel header="Pendência de mercado"><p>{pendenciaMercado.vecGateway.mensagem}</p></Panel>) : (
    <div>
      {pendenciaMercado.vecGateway.sintese_cadastral.cpf &&(
        <div>
          <Panel header={t('consumidor')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('documento')}</label>
                      <Chip style={{width:"100%"}} label={formatarCPF(numberFormat(pendenciaMercado.vecGateway.sintese_cadastral.cpf, 11))} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('nome')}</label>
                      <Chip style={{width:"100%"}} label={pendenciaMercado.vecGateway.sintese_cadastral.nome} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('nomeMae')}</label>
                      <Chip style={{width:"100%"}} label={pendenciaMercado.vecGateway.sintese_cadastral.nome_mae} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('tituloEleitor')}</label>
                      <Chip style={{width:"100%"}} label={pendenciaMercado.vecGateway.sintese_cadastral.titulo_eleitor ? pendenciaMercado.vecGateway.sintese_cadastral.titulo_eleitor : 'Não Informado'} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('dataNascimento')}</label>
                      <Chip style={{width:"100%"}} label={dateFormat(pendenciaMercado.vecGateway.sintese_cadastral.nascimento)} />
                  </div>
                </div>
                <div className="col">
              
                </div>
            </div>
          
          </Panel>
      
    
          {pendenciaMercado.vecGateway.consultas_anteriores_scpc && (
            <div>
              <br></br>
              <Panel header={t('consultas')}>
                <DataTable size="small" value={pendenciaMercado.vecGateway.consultas_anteriores_scpc.registros} tableStyle={{ minWidth: '50rem' }}>
                      <Column body={dateTemplate} header={t('data')}></Column>
                      <Column field="descricao" header={t('tipo')}></Column>
                      <Column field="informante" header={t('informante')}></Column>
                    
                  </DataTable>
              </Panel>
            </div>
          )}
          <br></br>
          <Panel headerTemplate={headerTemplate}>
            {!pendenciaMercado.vecGateway.registro_scpc_bvs.registros || pendenciaMercado.vecGateway.registro_scpc_bvs.registros.length === 0 ? ( <NadaConsta />) : (<>
            <DataTable size="small" value={pendenciaMercado.vecGateway.registro_scpc_bvs.registros} tableStyle={{ minWidth: '50rem' }}>
                <Column field="data_disponibilizacao" header={t('dataRegistro')}></Column>
                <Column field="data_ocorrencia" header={t('dataOcorrencia')}></Column>
                <Column field="contrato" header={t('contrato')}></Column>
                <Column field="situacao" header={t('situacao')}></Column>
                <Column field="tipo" header={t('tipo')}></Column>
                <Column field="informante" header={t('informante')}></Column>
                <Column field="uf" header={t('uf')}></Column>
                <Column field="valor" header={t('valor')}></Column>
            </DataTable>
            </>)}
          </Panel>
        </div>
      ) }
    
    {pendenciaMercado.vecGateway.sintese_cadastral.documento &&(
        <div>
          <Panel header={t('consumidor')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('documento')}</label>
                      <Chip style={{width:"100%"}} label={formatarCNPJ(numberFormat(pendenciaMercado.vecGateway.sintese_cadastral.documento, 14))} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('razaoSocial')}</label>
                      <Chip style={{width:"100%"}} label={pendenciaMercado.vecGateway.sintese_cadastral.razao_social} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('nomeFantasia')}</label>
                      <Chip style={{width:"100%"}} label={pendenciaMercado.vecGateway.sintese_cadastral.nome_fantasia ? pendenciaMercado.vecGateway.sintese_cadastral.nome_fantasia : 'Não Informado'} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('situacao')}</label>
                      <Chip style={{width:"100%"}} label={pendenciaMercado.vecGateway.sintese_cadastral.condicao} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('dataFundacao')}</label>
                      <Chip style={{width:"100%"}} label={dateFormat(pendenciaMercado.vecGateway.sintese_cadastral.data_fundacao)} />
                  </div>
                </div>
                <div className="col">
              
                </div>
            </div>
          
          </Panel>
          {pendenciaMercado.vecGateway.consultas_anteriores && (
            <div>
              <br></br>
              <Panel header={t('consultas')}>
                <DataTable size="small" value={pendenciaMercado.vecGateway.consultas_anteriores.ocorrencia} tableStyle={{ minWidth: '50rem' }}>
                      <Column body={dateTemplate} header={t('data')}></Column>
                      <Column field="descricao" header={t('informante')}></Column>
                  </DataTable>
              </Panel>
            </div>
          )}
          <br></br>
          <Panel headerTemplate={headerTemplate}>
            {!pendenciaMercado.vecGateway.debitos.ocorrencia || pendenciaMercado.vecGateway.debitos.ocorrencia.length === 0 ? ( <NadaConsta />) : (<>
            <DataTable size="small" value={pendenciaMercado.vecGateway.debitos.ocorrencia} tableStyle={{ minWidth: '50rem' }}>
                <Column body={dateRegistroTemplate} header={t('dataRegistro')}></Column>
                <Column body={dateOcorrenciaTemplate} header={t('dataOcorrencia')}></Column>
                <Column field="contrato" header={t('contrato')}></Column>
                <Column field="situacao" header={t('situacao')}></Column>
                <Column field="tipo" header={t('tipo')}></Column>
                <Column field="informante" header={t('informante')}></Column>
                <Column field="uf" header={t('uf')}></Column>
                <Column field="valorn" header={t('valor')}></Column>
            </DataTable>
            </>)}
          </Panel>
        </div>
      ) }
      
      
 
 
    </div>
    )}
    </div>
  )
}